import ReactGA from 'react-ga';
import TagManager from 'react-gtm-module'
import request from './request';

import HashCode from './HashCode';
import { getUserKey, setUserKey } from './SettingsRetriever';

const debug = true;
let sessionId = getUserKey();

export const initGA = (settings) => {
    let gaConfiguration = {};
    let tagConfiguration = {};
    let timestamp = parseInt(new Date().getTime() / 1000);

    if(sessionId) {
        if( (sessionId.timestamp + 3600) < timestamp ) {
            sessionId = false;
        }
    }

    if(!sessionId || !sessionId.timestamp) {
        sessionId = {
            id: HashCode(window.document.location.host+'+'+(timestamp)+'*'),
            timestamp: timestamp
        };
    }else{
        sessionId.timestamp = timestamp;
    }

    setUserKey(sessionId);

    if(settings && settings.analytics) {
        if(settings.analytics.ua) {
            gaConfiguration = settings.analytics.ua;
        }

        if(settings.analytics.gtm) {
            tagConfiguration = settings.analytics.gtm;
        }
    }

    if(gaConfiguration.code) {
        const gaArgs = {
            trackingId: gaConfiguration.code,
            debug: false,
            testMode: false,
            titleCase: false,
            gaOptions: {
                tracker: gaConfiguration.tracker,
                siteSpeedSampleRate: gaConfiguration.siteSpeedSampleRate || 5,
                clientId: sessionId.id
            }
        };

        ReactGA.initialize(gaArgs);
        if(debug){
            console.log('GA INIT', gaArgs);
        }
    }

    if(tagConfiguration.code) {
        const tagManagerArgs = {
            gtmId: tagConfiguration.code,
            dataLayer: {
                userProject: tagConfiguration.project,
                userId: sessionId.id
            }
        };

        TagManager.initialize(tagManagerArgs);
        if(debug){
            console.log('GTM INIT', tagManagerArgs);
        }
    }
}

export const GAPageView = (data) => {
    let customConfiguration = false;
    if(data.globalSettings && data.globalSettings.analytics) {
        if(data.globalSettings.analytics.custom) {
            customConfiguration = data.globalSettings.analytics.custom;
        }
    }

    if(data.sectionSettings.type) {
        setTimeout(function(){ 
            ReactGA.pageview(data.sectionSettings.type); 
        }, 3000);

        if(debug){
            console.log('GA PAGE VIEW', data.sectionSettings.type);
        }

        if(customConfiguration) {
            let trackEventArgs = {
                "event": "Load",
                "response": "Ok",
                "page": data.sectionSettings.type,
                "session_id": sessionId.id,
                "data": {}
            }

            if(data.sectionSettings.code && data.sectionSettings.code !== data.sectionSettings.type) {
                trackEventArgs.subpage = data.sectionSettings.code.toLowerCase();
            }

            if(data.page && data.page !== '') {
                trackEventArgs.page = data.page.toLowerCase();
            }

            if(data.subpage && data.subpage !== '') {
                trackEventArgs.subpage = data.subpage.toLowerCase();
            }

            if(data.email && data.email !== '') {
                trackEventArgs.email = data.email.toLowerCase();
            }

            if(data.sectionSettings.productSupercategoryId) {
                trackEventArgs.data.ProductSupercategoryId = parseInt(data.sectionSettings.productSupercategoryId);
            }

            if(data.sessionId && data.sessionId !== '') {
                trackEventArgs.data.SessionId = data.sessionId;
            }

            if(data.globalSettings.app && data.globalSettings.app.salesid) {
                trackEventArgs.data.SalesId = parseInt(data.globalSettings.app.salesid);
            }

            if(data.data) {
                trackEventArgs.data = {...trackEventArgs.data, ...data.data};
            }

            request({
                url: customConfiguration.source + '/trackEvent.html',
                method: 'GET',
                params: trackEventArgs
            });
        }
    }
}

export const GAevent = (categoryName, eventName) => {
    ReactGA.event({
        category: categoryName,// String. Required. A top level category for these events. E.g. 'User', 'Navigation', 'App Editing', etc.
        action: eventName,// String. Required. A description of the behaviour. E.g. 'Clicked Delete', 'Added a component', 'Deleted account', etc.
        label: 'labelName', // String. Optional. More precise labelling of the related action. E.g. alongside the 'Added a component' action, we could add the name of a component as the label. E.g. 'Survey', 'Heading', 'Button', etc.
        value: 10, //Int. Optional. A means of recording a numerical value against an event. E.g. a rating, a score, etc.
        nonInteraction: false, //Boolean. Optional. If an event is not triggered by a user interaction, but instead by our code (e.g. on page load, it should be flagged as a nonInteraction event to avoid skewing bounce rate data.
        transport: 'image'//String. Optional. This specifies the transport mechanism with which hits will be sent. Valid values include 'beacon', 'xhr', or 'image'.
    });
}

export const GATiming = (data) => {
    let customConfiguration = false;
    if(data.globalSettings && data.globalSettings.analytics) {
        if(data.globalSettings.analytics.custom) {
            customConfiguration = data.globalSettings.analytics.custom;
        }
    }
    // ReactGA.timing({
    //     category: categoryName, //String. Required. A string for categorizing all user timing variables into logical groups.
    //     variable: variableName, //String. Required. Name of the variable being recorded.
    //     value: valueNum, //Int. Required. Number of milliseconds elapsed time to report.
    //     label: '' //String. Optional. It can be used to add flexibility in visualizing user timings in the reports.
    // });
    if(data.initial && data.sectionSettings && data.sectionSettings.type) {
        const now = parseInt(new Date().getTime());
        const initial = parseInt(data.initial);

        let timingArgs = {
            category: data.sectionSettings.type,
            variable: 'load',
            value: (now - initial)
        }

        if(data.sectionSettings.code && data.sectionSettings.code !== data.sectionSettings.type) {
            timingArgs.category = data.sectionSettings.code.toLowerCase();
        }

        if(data.page) {
            timingArgs.category = data.page;
        }

        ReactGA.timing(timingArgs);

        if(debug) {
            console.log('ga timing', timingArgs);
        }

        if(customConfiguration) {
            let trackEventArgs = {
                "event": "LoadTime",
                "response": "Ok",
                "section": timingArgs.category,
                "count": timingArgs.value,
                "session_id": sessionId.id
            }

            if(data.data) {
                trackEventArgs.data = data.data;
            }

            request({
                url: customConfiguration.source + '/trackEvent.html',
                method: 'GET',
                params: trackEventArgs
            });
        }
    }
}

export const pushDataLayer = (data) => {
    let tagConfiguration = false;
    if(data.globalSettings && data.globalSettings.analytics) {
        if(data.globalSettings.analytics.gtm) {
            tagConfiguration = data.globalSettings.analytics.gtm;
        }
    }

    if(tagConfiguration && data.data) {
        if(data.event === 'purchase') {
            data.data.transactionAffiliation = tagConfiguration.project;
            data.data.event = 'conversion';
        }

        let tagManagerArgs = {
            dataLayer: data.data
        };

        TagManager.dataLayer(tagManagerArgs);
    }
}